import $ from 'jquery';
import {setCookie} from './cookie';

const disclaimerForm = (el) => {
    const $el = $(el);
    $el.on('submit', (e) => {
        e.preventDefault();
        const id = $el.find('[name=disclaimer_id]').val();
        setCookie(`carnegie_disclaimer_form_accepted_${id}`, 'true');
        window.scrollTo({ top: 0 });
        window.location.reload();
    });
};

export default disclaimerForm;
